const config = {
    companyId: 9,
    apiUrl: process.env.REACT_APP_MJR_API,
    apiVersion: '/v4',
    registerUrl: '/public/client/register',
    userInfoUrl: '/client/user',
    userRequirementsUrl: '/client/user/requirements',
    clientRequirementsUrl: '/client/user/requirements',
    customerInfoUrl: '/client/customers',
    clientInfoUrl: '/client/customer',
    signContractUrl: '/client/customer',
    mlThreshold: 22,
    timeoutToManualPhoto: 15000,
    dlFrontOcrUrl: 'https://kav2gomanager.herokuapp.com/ocr/document/dl/front',
    dlBackOcrUrl: 'https://kav2gomanager.herokuapp.com/ocr/document/dl/back',
    pasFrontOcrUrl: 'https://kav2gomanager.herokuapp.com/ocr/document/international_passport/front',
    idCardFrontOcrUrl: 'https://kav2gomanager.herokuapp.com/ocr/document/id_card/front',
    idCardBackOcrUrl: 'https://kav2gomanager.herokuapp.com/ocr/document/id_card/back',
    experianDLUrl: 'https://api.mobielrijden.nl/v4/public/screener/experian',
    build: process.env.NODE_ENV, //development | production

    _getPreUrl: function () {
        return this.apiUrl + this.apiVersion + '/' + this.companyId
    },

    getUploadDriverLicenseUrl: function () {
        return this._getPreUrl() + '/client/user/documents';
    },

    getSignContractUrl: function (customerId) {
        return this._getPreUrl() + this.signContractUrl + '/' + customerId + '/contract';
    },

    getShortRegisterUrl: function () {
        return this.apiUrl + this.apiVersion + '/' + this.companyId + this.registerUrl
    },

    getUserInfoUrl: function () {
        return this._getPreUrl() + this.userInfoUrl
    },

    getCustomerInfoUrl: function () {
        return this._getPreUrl() + this.customerInfoUrl
    },

    getClientRequirementsUrl: function (clientId) {
        return this._getPreUrl() + this.clientInfoUrl + '/' + clientId + '/requirements';
    },

    getUserRequirementsUrl: function (userId) {
        return this._getPreUrl() + this.userRequirementsUrl;
    },

    getFullUpdateUrl: function () {
        return this._getPreUrl() + '/client/user';
    },

    getAllDocumentsUrl: function () {
        return this._getPreUrl() + '/client/user/documents';
    },

    getPaymentUrl: function (customerId) {
        return this._getPreUrl() + '/client/customer/' + customerId + '/payment-request-bunq';
    },

    getEditBankInformationUrl: function (customerId) {
        return this._getPreUrl() + '/client/customer/' + customerId;
    },

    getLoginUrl: function () {
        return this._getPreUrl() + '/public/client/login';
    },

    getResetLinkUrl: function () {
        return this._getPreUrl() + '/public/client/reset-password';
    },

    getBlockPaymentStatus: function () {
        return 'pending'
    },

    getContractSignedType: function () {
        return 'contract_signed'
    },

    getRegistrationFeeType: function () {
        return 'registration_fee'
    },

    getBankInformationType: function () {
        return 'bank_information'
    },

    getUserBasicInformationType: function () {
        return 'user_basic_info'
    },

    getDriversLicenseType: function () {
        return 'drivers_license'
    },

    getIdCardType: function () {
        return 'id_card'
    },

    getPassportType: function () {
        return 'passport'
    },

    getSuccessUrl: function () {
        return 'https://kav2go.nl/success/'
    },

    getRestorePasswordLink: function () {
        return this._getPreUrl() + '/public/client/reset-password'
    },

    getImageCropToolUrl: function () {
        return 'https://kav2go.nl/resize.php'
    },

    getGAId: function () {
        return 'UA-211006469-1'
    },

    getRemoveDLUrl: function (api) {
        return this._getPreUrl() + '/client/user/documents'
    },

    getDriversLicenseOCR: function () {
        return 'https://dev.kav2go.nl/api/document/dispatch'
    },

    getZipCodeUrl: function ({
                                 zipCode,
                                 houseNumber,
                                 additionalHouseNumber
                             }) {

        return `https://kav2gomanager.herokuapp.com/postcode/${zipCode}/${houseNumber}/${additionalHouseNumber}`
    }
}

export default config